const actions = {
  SET_STATE: 'season/SET_STATE',
  REFRESH_ERRORS: 'season/REFRESH_ERRORS',
  ACTIVE: 'season/ACTIVE',
  SELECT: 'season/SELECT',
  ALL: 'season/ALL',
  FETCH_ALL: 'season/FETCH_ALL',
  DETAILS: 'season/DETAILS',
  ADD: 'season/ADD',
  EDIT: 'season/EDIT',
  REMOVE: 'season/REMOVE'
};

export default actions
